import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { MoneyApi } from "go-core/api/types";
import FormatMoney from "go-core/components/Formatters/FormatMoney";
import { selectOrganization } from "go-security/services/organizations/selectors";
import { InvoiceCalculationType } from "../../../../../../../../../../../services/Api/Organization/types";

interface Props {
	calculationType: InvoiceCalculationType;
	totalPrice?: MoneyApi;
	paidPrice?: MoneyApi;
}

const InvoiceFormItemsTableSummary = ({ calculationType, totalPrice, paidPrice }: Props) => {
	const { t } = useTranslation();
	const organization = useSelector(selectOrganization);
	const currency = organization.currency ?? "";
	const priceToPay = {
		amount: (totalPrice?.amount || 0) - (paidPrice?.amount || 0),
		currency: totalPrice?.currency ?? currency,
	};

	return (
		<>
			<tr className="summary with-padding">
				<td colSpan={7} />
				<td colSpan={2} className="nowrap">
					{t("modules.invoice.field.price_paid.title")}
				</td>
				<td colSpan={2} className="nowrap text-end">
					{FormatMoney(paidPrice ?? { amount: 0, currency })}
				</td>
			</tr>
			<tr className="summary">
				<td colSpan={7} />
				<td colSpan={2} className="nowrap">
					{calculationType === InvoiceCalculationType.GROSS
						? t("modules.invoice.field.price_sum_gross.title")
						: t("modules.invoice.field.price_sum_net.title")}
				</td>
				<td colSpan={2} className="nowrap text-end">
					{FormatMoney(totalPrice)}
				</td>
			</tr>
			<tr className="summary ">
				<td colSpan={7} />
				<td colSpan={2} className="nowrap">
					{t("modules.invoice.field.amount_to_pay.title")}
				</td>
				<td colSpan={2} className="nowrap text-end">
					{FormatMoney(priceToPay)}
				</td>
			</tr>
		</>
	);
};

export default InvoiceFormItemsTableSummary;
